export const BranchData = [
    {
      "branchId": "B001",
      "branchName": "Kathmandu Main Branch",
      "managerName": "Anup Shakya",
      "email": "kathmandu.branch@example.com",
      "phone": "+977-9851001122",
      "location": "Tripureshwor, Kathmandu",
      "totalUsers": 125,
      "activeDisputes": 14,
      "resolvedDisputes": 108,
      "performanceScore": 92,
      "status": "Active",
      "lastUpdated": "2025-11-02T09:45:00Z",
      "createdDate": "2023-09-10T08:00:00Z"
    },
    {
      "branchId": "B002",
      "branchName": "Pokhara Regional Office",
      "managerName": "Bishal Gurung",
      "email": "pokhara.office@example.com",
      "phone": "+977-9802334455",
      "location": "New Road, Pokhara",
      "totalUsers": 89,
      "activeDisputes": 6,
      "resolvedDisputes": 72,
      "performanceScore": 88,
      "status": "Active",
      "lastUpdated": "2025-10-29T15:20:00Z",
      "createdDate": "2024-01-15T10:30:00Z"
    },
    {
      "branchId": "B003",
      "branchName": "Biratnagar Branch",
      "managerName": "Suman Rai",
      "email": "biratnagar.branch@example.com",
      "phone": "+977-9811102233",
      "location": "Traffic Chowk, Biratnagar",
      "totalUsers": 67,
      "activeDisputes": 9,
      "resolvedDisputes": 55,
      "performanceScore": 84,
      "status": "Active",
      "lastUpdated": "2025-11-03T12:15:00Z",
      "createdDate": "2024-05-20T14:00:00Z"
    },
    {
      "branchId": "B004",
      "branchName": "Butwal Service Center",
      "managerName": "Rita Khatri",
      "email": "butwal.center@example.com",
      "phone": "+977-9861003344",
      "location": "Traffic Chowk, Butwal",
      "totalUsers": 53,
      "activeDisputes": 3,
      "resolvedDisputes": 48,
      "performanceScore": 95,
      "status": "Active",
      "lastUpdated": "2025-10-27T16:00:00Z",
      "createdDate": "2023-11-18T09:30:00Z"
    },
    {
      "branchId": "B005",
      "branchName": "Dharan Branch",
      "managerName": "Prakash Subba",
      "email": "dharan.branch@example.com",
      "phone": "+977-9821334455",
      "location": "BP Chowk, Dharan",
      "totalUsers": 74,
      "activeDisputes": 7,
      "resolvedDisputes": 61,
      "performanceScore": 89,
      "status": "Active",
      "lastUpdated": "2025-11-01T11:05:00Z",
      "createdDate": "2024-03-22T08:45:00Z"
    },
    {
      "branchId": "B006",
      "branchName": "Chitwan Sub-Branch",
      "managerName": "Nabin Acharya",
      "email": "chitwan.subbranch@example.com",
      "phone": "+977-9819988776",
      "location": "Bharatpur, Chitwan",
      "totalUsers": 41,
      "activeDisputes": 5,
      "resolvedDisputes": 36,
      "performanceScore": 83,
      "status": "Active",
      "lastUpdated": "2025-11-04T09:10:00Z",
      "createdDate": "2024-08-05T10:00:00Z"
    },
    {
      "branchId": "B007",
      "branchName": "Lalitpur Help Desk",
      "managerName": "Mina Shrestha",
      "email": "lalitpur.helpdesk@example.com",
      "phone": "+977-9845011223",
      "location": "Jawalakhel, Lalitpur",
      "totalUsers": 92,
      "activeDisputes": 11,
      "resolvedDisputes": 76,
      "performanceScore": 86,
      "status": "Under Maintenance",
      "lastUpdated": "2025-10-25T08:30:00Z",
      "createdDate": "2023-12-10T11:15:00Z"
    },
    {
      "branchId": "B008",
      "branchName": "Nepalgunj Regional Branch",
      "managerName": "Suresh Chaudhary",
      "email": "nepalgunj.branch@example.com",
      "phone": "+977-9867004455",
      "location": "Birendra Chowk, Nepalgunj",
      "totalUsers": 63,
      "activeDisputes": 4,
      "resolvedDisputes": 51,
      "performanceScore": 90,
      "status": "Inactive",
      "lastUpdated": "2025-09-14T13:00:00Z",
      "createdDate": "2023-08-20T09:00:00Z"
    }
]